import { ref } from 'vue';

/**
 * useFlowProgress — module-singleton store for the current immersive flow's
 * step progress + an animation lock.
 *
 * Mirrors the module-level-ref singleton pattern in useCreateReading.ts: the
 * refs live at module scope so every caller (the wizard that drives a flow, the
 * FlowHeader that renders its progress dots, a draw that locks navigation
 * during its animation) shares one source of truth.
 *
 * - `count`   total number of steps in the active flow (0/1 = no progress dots)
 * - `current` zero-based index of the active step
 * - `locked`  true while a blocking animation is running; goUp() no-ops on it
 */
const count = ref(0);
const current = ref(0);
const locked = ref(false);

export function useFlowProgress() {
  const setProgress = (newCount: number, newCurrent: number) => {
    count.value = newCount;
    current.value = newCurrent;
  };

  const clear = () => {
    count.value = 0;
    current.value = 0;
  };

  const setLocked = (value: boolean) => {
    locked.value = value;
  };

  return {
    count,
    current,
    locked,
    setProgress,
    clear,
    setLocked,
  };
}
